const hasRelationship = require("./hasRelationship");

module.exports = function getTabData(entity) {
	const tab_data = hasRelationship(entity.relationships.field_accordion_components)
		? entity.relationships.field_accordion_components.data
		: [];
	return tab_data;
};
